import { render, staticRenderFns } from "./prestation.vue?vue&type=template&id=65521a03&scoped=true&"
import script from "./prestation.vue?vue&type=script&lang=ts&setup=true&"
export * from "./prestation.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./prestation.vue?vue&type=style&index=0&id=65521a03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65521a03",
  null
  
)

export default component.exports